<template>
  <component
    :is="iconComponent"
    v-if="iconComponent"
    :class="iconClass"
    data-test="dynamic-icon"
    :size
  />

  <div
    v-else
    :class="placeholderSizeClass"
    data-test="dynamic-icon-placeholder"
  />
</template>

<script setup lang="ts">
import { computed, toRefs } from 'vue'

import type { SizeNames } from '@ds/components/Icon'

import type { DynamicIconProps } from './DynamicIcon.types'
import { useColorClass } from './helpers/useColorClass'
import { useIcon } from './helpers/useIcon'

/**
 * TODO: add unit tests to this component
 */

const props = withDefaults(defineProps<DynamicIconProps>(), {
  size: 'small',
  color: 'primary',
  extraClass: '',
})

const colorClass = useColorClass(toRefs(props).color)
const iconClass = computed(() => `${colorClass.value} ${props.extraClass}`)

const ICON_SIZE_TO_SIZE_CLASS: Record<SizeNames, string> = {
  'extra-small': 'w-12 h-12',
  small: 'w-16 h-16',
  medium: 'w-24 h-24',
  large: 'w-48 h-48',
}

const sizeClass = computed(() => {
  if (!props.size) return ICON_SIZE_TO_SIZE_CLASS.medium

  return ICON_SIZE_TO_SIZE_CLASS[props.size]
})
const placeholderSizeClass = computed(
  () => `${sizeClass.value} ${props.extraClass}`,
)

const { iconComponent, fetchIconComponent } = useIcon(toRefs(props).icon)

// awaiting in the setup function instead of onMounted to fix hydration mismatch issues
if (import.meta.client) {
  await fetchIconComponent()
}
</script>
